import React from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDateTimePicker from '@mui/lab/DesktopDateTimePicker';
import ModernDatepicker from 'react-modern-datepicker';
import calendar from '../images/calendar.jpg';

const DateField = ({
    value,
    onChange,
    name,
    muidate = false
}) => {

    return (
        <>
            {
                !muidate ?
                    <ModernDatepicker
                        date={value}
                        showBorder
                        icon={calendar}
                        onChange={date => onChange(date, name, "date")}
                        style={{ borderRadius: "5px" }}
                        placeholder={'Select a date'}
                    /> :
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                            <DesktopDateTimePicker
                                value={value || new Date()}
                                showTodayButton
                                onChange={(e) => onChange(e, name, "date")}
                                renderInput={(params) => <TextField className="form-control" {...params} />}
                            />
                        </Stack>
                    </LocalizationProvider>}
        </>
    );
}

export default DateField;